<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="予約データ出力">
        <el-form v-model="form">
          <el-form-item label="対象店舗">
            <el-transfer v-model="form.shops" class="csv-shop-select" :data="transferShop"></el-transfer>
          </el-form-item>
          <el-form-item label="お客様情報">
            <el-transfer v-model="form.customer" class="csv-shop-select" :data="customer"></el-transfer>
          </el-form-item>
          <el-form-item label="予約情報">
            <el-transfer v-model="form.reserve" class="csv-shop-select" :data="reserve"></el-transfer>
          </el-form-item>
          <el-form-item label="施術履歴">
            <el-transfer v-model="form.history" class="csv-shop-select" :data="history"></el-transfer>
          </el-form-item>
          <el-form-item label="対象日">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              align="right"
              start-placeholder="開始日"
              end-placeholder="終了日"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <el-button type="success" icon="el-icon-download" @click="submit">CSV出力</el-button>
        <el-button type="danger" v-show="isDownloading" @click="doCancel" :disabled="cancel">中止</el-button>
        <div v-show="isDownloading && progress.total">
          <el-progress type="circle" :percentage="progressPercentage" color="#67c23a"></el-progress>
          {{ progress.total }}件中 {{ progress.offset }}件取得
        </div>
      </el-tab-pane>
      <el-tab-pane label="顧客データ出力">
        <el-form v-model="form">
          <el-form-item label="お客様情報">
            <el-transfer v-model="form.customer_db" class="csv-shop-select" :data="customer_db"></el-transfer>
          </el-form-item>
        </el-form>
        <el-button type="success" icon="el-icon-download" @click="submit2">CSV出力</el-button>
        <el-button type="danger" v-show="isDownloading" @click="doCancel" :disabled="cancel">中止</el-button>
        <div v-show="isDownloading && progress.total">
          <el-progress type="circle" :percentage="progressPercentage" color="#67c23a"></el-progress>
          {{ progress.total }}件中 {{ progress.offset }}件取得
        </div>
      </el-tab-pane>
      <el-tab-pane label="施術履歴データ出力">
        <el-form v-model="form">
          <el-form-item label="施術履歴">
            <el-transfer v-model="form.history_db" class="csv-shop-select" :data="history_db"></el-transfer>
          </el-form-item>
          <el-form-item label="対象日">
            <el-date-picker
              v-model="form.date"
              type="daterange"
              align="right"
              start-placeholder="開始日"
              end-placeholder="終了日"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <el-button type="success" icon="el-icon-download" @click="submit3">CSV出力</el-button>
        <el-button type="danger" v-show="isDownloading" @click="doCancel" :disabled="cancel">中止</el-button>
        <div v-show="isDownloading && progress.total">
          <el-progress type="circle" :percentage="progressPercentage" color="#67c23a"></el-progress>
          {{ progress.total }}件中 {{ progress.offset }}件取得
        </div>
      </el-tab-pane>

      <el-tab-pane label="fufuアプリユーザー出力">
        <el-form v-model="form">
          <el-form-item label="FUFUユーザ情報">
            <el-transfer v-model="form.fufuuser" class="csv-shop-select" :data="fufuUser"></el-transfer>
          </el-form-item>
        </el-form>
        <el-button type="success" icon="el-icon-download" @click="submit4">CSV出力</el-button>
        <el-button type="danger" v-show="isDownloading" @click="doCancel" :disabled="cancel">中止</el-button>
        <div v-show="isDownloading && progress.total">
          <el-progress type="circle" :percentage="progressPercentage" color="#67c23a"></el-progress>
          {{ progress.total }}件中 {{ progress.offset }}件取得
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from 'moment'
import ShopType from '@/consts/ShopType'

import downloadCsv from '@/misc/downloadCsv'
// import reservationCsv from './csv/reservation'

class Interrupt extends Error {}

export default {
  name: 'CsvIndex',
  data () {
    return {
      isLoading: false,
      isDownloading: false,
      shops: [],
      shopfields: [{ key: 'shopCode', label: '店舗コード' }, { key: 'shopName', label: '店舗名' }],
      shopData: ['shopCode', 'shopName'],
      customer_db: [
        { key: 'pk', label: 'id' },
        { key: 'uuid', label: 'uuid' },
        { key: 'shopCode', label: '店舗コード' },
        { key: 'shopName', label: '店舗名' },
        { key: 'familyName', label: '姓' },
        { key: 'firstName', label: '名' },
        { key: 'fullName', label: '姓名' },
        { key: 'familyNameKana', label: 'セイ' },
        { key: 'firstNameKana', label: 'メイ' },
        { key: 'fullnameKana', label: 'セイメイ' },
        { key: 'account', label: 'お客様番号' },
        { key: 'email', label: 'Eメール' },
        { key: 'age', label: '年代' },
        { key: 'gender', label: '性別' },
        { key: 'phoneNumber', label: '電話番号' },
        { key: 'postcode', label: '郵便番号' },
        { key: 'prefecture', label: '都道府県' },
        { key: 'city', label: '市町村' },
        { key: 'address', label: '町名番地' },
        { key: 'building', label: 'ビル名等' },
        { key: 'note', label: '備考' },
        { key: 'visitReasons', label: '来店のきっかけ' },
        { key: 'visitReasonOther', label: 'fufuを知ったきっかけ(その他)' },
        { key: 'knownReasons', label: 'fufuを知ったきっかけ' },
        { key: 'knownReasonOther', label: '来店のきっかけ(その他)' },
        { key: 'maxVisitShopName', label: '最多来店店舗' },
        { key: 'firstVisit', label: '初回来店日' },
        { key: 'lastVisit', label: '最終来店日' },
        { key: 'visitCount', label: '来店回数' },
        { key: 'firstReservedBy', label: '初回来店経路' },
        { key: 'createdAt', label: '作成日' },
        { key: 'updatedAt', label: '更新日' },
      ],
      customer: [
        { key: 'customerUuid', label: 'UUID' },
        { key: 'customerPk', label: 'ID' },
        { key: 'customerFamilyName', label: '姓' },
        { key: 'customerFirstName', label: '名' },
        { key: 'customerFamilyNameKana', label: 'セイ' },
        { key: 'customerFirstNameKana', label: 'メイ' },
        { key: 'customerAccount', label: 'お客様番号' },
        { key: 'customerOldAccount', label: '旧アカウント' },
        { key: 'customerEmail', label: 'メールアドレス' },
        { key: 'customerAge', label: '年代' },
        { key: 'customerGender', label: '性別' },
        { key: 'customerBirthday', label: '誕生日' },
        { key: 'customerPhoneNumber', label: '電話番号' },
        { key: 'customerPostcode', label: '郵便番号' },
        { key: 'customerPrefecture', label: '都道府県' },
        { key: 'customerCity', label: '市区町村郡' },
        { key: 'customerAddress', label: '町名番地' },
        { key: 'customerBuilding', label: 'ビル名等' },
        { key: 'customerNote', label: '備考' },
        { key: 'customerVisitReasons', label: '来店のきっかけ' },
        { key: 'customerKnownReasons', label: 'fufuを知ったきっかけ' },
        { key: 'customerVisitReasonOther', label: '来店のきっかけ(その他)' },
        { key: 'customerKnownReasonOther', label: 'fufuを知ったきっかけ(その他)' },
      ],
      reserve: [
        { key: 'reserverAccount', label: 'お客様番号' },
        { key: 'phone_number', label: '電話番号' },
        { key: 'reserverNameWithoutSpace', label: '氏名' },
        { key: 'reserverFamilyName', label: '姓' },
        { key: 'reserverFirstName', label: '名' },
        { key: 'reserverNameKanaWithoutSpace', label: 'シメイ' },
        { key: 'reserverFamilyNameKana', label: 'セイ' },
        { key: 'reserverFirstNameKana', label: 'メイ' },
        { key: 'reserverNote ', label: 'メモ' },
        { key: 'reserverCrmUploadedAt', label: 'crmアップロード日時' },
        { key: 'reserverPrevVisitDate', label: '前回来店日' },
        { key: 'reserverVisitCount', label: '総来店回数' },
        { key: 'reserverYearVisitCount', label: '年間来店回数' },
        { key: 'reserverOnVisitCount', label: '来店回数' },
        { key: 'reserverAllPrevVisitDate', label: '前回来店日' },
        { key: 'reserverAllVisitCount', label: '総来店回数' },
        { key: 'reserverAllYearVisitCount', label: '年間来店回数' },
        { key: 'reserverAllOnVisitCount', label: '来店価数' },
        { key: 'status', label: '状態' },
        { key: 'reservedBy', label: '予約方法' },
        { key: 'date', label: '予約日' },
        { key: 'startHour', label: '開始時間(時)' },
        { key: 'startMinute', label: '開始時間(分)' },
        { key: 'endHour', label: '終了時間(時)' },
        { key: 'endMinute', label: '終了時間(分)' },
        { key: 'attendedStaff', label: '予約対応スタッフ' },
        { key: 'attendedStaffName', label: '予約対応スタッフ名' },
        { key: 'respondingStaff ', label: '対応予定スタッフ' },
        { key: 'respondingStaffName', label: '対応予定スタッフ名' },
        { key: 'respondingShampooStaff ', label: 'シャンプー対応予定スタッフ' },
        { key: 'respondingShampooStaffName', label: 'シャンプー対応予定スタッフ名' },
        { key: 'menu', label: 'メニュー' },
        { key: 'menuOptions', label: 'メニューオプション' },
        { key: 'note', label: 'メモ' },
        { key: 'reserver', label: '予約者情報' },
        { key: 'isRemoved', label: '削除済み予約' },
        { key: 'isRepeatInMonth', label: '30日以内の再来店' },
        { key: 'hotpepperReservationNo', label: 'ホットペッパー予約番号' },
        { key: 'hotpepperPoint', label: 'ホットペッパーポイント' },
        { key: 'memo', label: '予約メモ' },
        { key: 'parseWarning', label: '取り込み不具合' },
        { key: 'prevReservation', label: '前回の予約' },
      ],
      history: [
        { key: 'operationHistoryScalpProtectiveAgent', label: '頭皮保護剤' },
        { key: 'operationHistoryTreatment', label: 'トリートメント' },
        { key: 'operationHistoryNote', label: '備考' },
        { key: 'operationHistoryTreatmentStaff', label: '施術対応スタッフ' },
        { key: 'operationHistoryTreatmentStaffName', label: '施術対応スタッフ名' },
        { key: 'operationHistoryCounselingStaff', label: 'カウンセリングスタッフ' },
        { key: 'operationHistoryDyeingStaff_1', label: '塗布対応スタッフ1' },
        { key: 'operationHistoryDyeingStaff_1_name', label: '塗布対応スタッフ名1' },
        { key: 'operationHistoryDyeingStaff_2', label: '塗布対応スタッフ2' },
        { key: 'operationHistoryDyeingStaff_2_name', label: '塗布対応スタッフ名2' },
        { key: 'operationHistoryShampooStaff', label: 'シャンプー対応スタッフ' },
        { key: 'operationHistoryShampooStaffName ', label: 'シャンプー対応スタッフ名' },
      ],
      fufuUser: [
        { key: 'username', label: 'ユーザー名' },
        { key: 'email', label: 'メールアドレス' },
        { key: 'firstName', label: '名' },
        { key: 'familyName', label: '姓' },
        { key: 'fullName', label: '姓名' },
        { key: 'familyNameKana', label: 'セイ' },
        { key: 'firstNameKana', label: 'メイ' },
        { key: 'fullnameKana', label: 'セイメイ' },
        { key: 'phoneNumber', label: '電話番号' },
        { key: 'authenticationCode', label: '正登録有無フラグ' },
        { key: 'customer[0].account', label: 'お客さま番号' },
      ],
      history_db: [
        { key: 'uuid', label: 'UUID' },
        { key: 'id', label: 'ID' },
        { key: 'date', label: '予約日' },
        { key: 'scalpProtectiveAgent', label: '頭皮保護剤' },
        { key: 'treatment', label: 'トリートメント' },
        { key: 'note', label: '備考' },
        { key: 'operationHistoryTreatmentStaff', label: '施術対応スタッフ' },
        { key: 'treatmentStaffName', label: '施術対応スタッフ名' },
        { key: 'counselingStaff', label: 'カウンセリングスタッフ' },
        { key: 'dyeingStaff_1', label: '塗布対応スタッフ1' },
        { key: 'dyeingStaff_1_name', label: '塗布対応スタッフ名1' },
        { key: 'dyeingStaff_2', label: '塗布対応スタッフ2' },
        { key: 'dyeingStaff_2_name', label: '塗布対応スタッフ名2' },
        { key: 'shampooStaff', label: 'シャンプー対応スタッフ' },
        { key: 'shampooStaffName ', label: 'シャンプー対応スタッフ名' },
      ],
      form: {
        shops: [],
        customer: [],
        customer_db: [],
        reserve: [],
        history: [],
        fufuuser: [],
        history_db: [],
        date: '',
        dataType: 'reservation',
      },
      fields: {},
      allFields: [],
      cancel: false,
      progress: {
        total: 0,
        offset: 0,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今月',
            onClick (picker) {
              const start = moment().startOf('month')
              const end = moment().endOf('month')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '先月',
            onClick (picker) {
              const start = moment()
                .add('months', -1)
                .startOf('month')
              const end = moment()
                .add('months', -1)
                .endOf('month')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '先々月',
            onClick (picker) {
              const start = moment()
                .add('months', -2)
                .startOf('month')
              const end = moment()
                .add('months', -2)
                .endOf('month')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  computed: {
    transferShop () {
      return this.shops.map(obj => {
        return {
          key: obj.pk,
          label: `${obj.name} (${obj.code})`,
        }
      })
    },
    progressPercentage () {
      return this.progress.total ? Math.round((this.progress.offset / this.progress.total) * 1000) / 10 : 0
    },
  },
  mounted () {
    this.fetchShopData()
  },
  methods: {
    submit () {
      if (this.isDownloading) {
        return
      }
      let params = {}
      if (this.form.date.length) {
        params['from_date'] = moment(this.form.date[0]).format('YYYY-MM-DD')
        params['to_date'] = moment(this.form.date[1]).format('YYYY-MM-DD')
      }
      if (this.form.shops.length) {
        params['shops'] = this.form.shops
      }
      this.fields = this.shopData.concat(this.form.customer.concat(this.form.reserve.concat(this.form.history)))
      // TODO
      this.makeallFiels(0)
      this.outputReservation(params)
    },
    submit2 () {
      if (this.isDownloading) {
        return
      }
      this.fields = this.form.customer_db
      // TODO
      this.makeallFiels(1)
      this.outputReservationCustomer()
    },
    submit3 () {
      if (this.isDownloading) {
        return
      }
      let params = {}
      if (this.form.date.length) {
        params['from_date'] = moment(this.form.date[0]).format('YYYY-MM-DD')
        params['to_date'] = moment(this.form.date[1]).format('YYYY-MM-DD')
      }
      this.fields = this.form.history_db
      // TODO
      this.makeallFiels(2)
      this.outputOperationHistory(params)
    },
    submit4 () {
      if (this.isDownloading) {
        return
      }
      this.fields = this.form.fufuuser
      // TODO
      this.makeallFiels(1)
      this.outputReservationFufuUser()
    },
    makeallFiels (a) {
      var tmp = {}
      let concatField = []
      if (a === 0) {
        concatField = this.shopfields.concat(this.customer.concat(this.reserve.concat(this.history)))
      }
      if (a === 1) {
        concatField = this.customer_db
      }
      if (a === 2) {
        concatField = this.history_db
      }
      concatField.forEach(function (value) {
        tmp[value['key']] = value['label']
      })
      this.allFields = tmp
    },
    doCancel () {
      this.$confirm('処理を中止しますか？', 'Warning', {
        confirmButtonText: '中止する',
        cancelButtonText: '中止しない',
      }).then(() => {
        this.cancel = true
      })
    },
    outputReservation (params) {
      this.isDownloading = true
      this.progress.total = 0
      this.progress.offset = 0
      const progressFn = function (total, offset) {
        this.progress.total = total
        this.progress.offset = offset
        if (this.cancel) {
          this.cancel = false
          throw new Interrupt()
        }
      }.bind(this)
      this.$request.reservations
        .csvData(params, progressFn)
        .then(items => {
          const tmp = this.reservationCsv(items)
          var m = moment()
          var output = m.format('YYYYMMDDHHmm')
          const fName = 'reservation_' + output + '.csv'
          downloadCsv(fName, tmp.header, tmp.data)
        })
        .catch(err => {
          if (err.status) {
            this.$notify({
              title: 'API Error',
              message: 'APIサーバでエラーが発生しました',
              type: 'error',
              duration: 10,
            })
          } else {
            this.$notify({
              message: '処理を中止しました',
            })
          }
          console.log(err)
        })
        .finally(() => {
          this.isDownloading = false
        })
    },
    outputReservationCustomer () {
      this.isDownloading = true
      this.progress.total = 0
      this.progress.offset = 0
      const progressFn = function (total, offset) {
        this.progress.total = total
        this.progress.offset = offset
        if (this.cancel) {
          this.cancel = false
          throw new Interrupt()
        }
      }.bind(this)
      this.$request.reservations
        .csvCustomerData(progressFn)
        .then(items => {
          const tmp = this.reservationCsv(items)
          var m = moment()
          var output = m.format('YYYYMMDDHHmm')
          const fName = 'user_' + output + '.csv'
          downloadCsv(fName, tmp.header, tmp.data)
        })
        .catch(err => {
          if (err.status) {
            this.$notify({
              title: 'API Error',
              message: 'APIサーバでエラーが発生しました',
              type: 'error',
              duration: 10,
            })
          } else {
            this.$notify({
              message: '処理を中止しました',
            })
          }
          console.log(err)
        })
        .finally(() => {
          this.isDownloading = false
        })
    },
    outputReservationFufuUser () {
      this.isDownloading = true
      this.progress.total = 0
      this.progress.offset = 0
      const progressFn = function (total, offset) {
        this.progress.total = total
        this.progress.offset = offset
        if (this.cancel) {
          this.cancel = false
          throw new Interrupt()
        }
      }.bind(this)
      this.$request.reservations
        .csvFufuUserData(progressFn)
        .then(items => {
          const tmp = this.reservationCsv(items)
          var m = moment()
          var output = m.format('YYYYMMDDHHmm')
          const fName = 'fufuappuser_' + output + '.csv'
          downloadCsv(fName, tmp.header, tmp.data)
        })
        .catch(err => {
          if (err.status) {
            this.$notify({
              title: 'API Error',
              message: 'APIサーバでエラーが発生しました',
              type: 'error',
              duration: 10,
            })
          } else {
            this.$notify({
              message: '処理を中止しました',
            })
          }
          console.log(err)
        })
        .finally(() => {
          this.isDownloading = false
        })
    },
    outputOperationHistory (params) {
      this.isDownloading = true
      this.progress.total = 0
      this.progress.offset = 0
      const progressFn = function (total, offset) {
        this.progress.total = total
        this.progress.offset = offset
        if (this.cancel) {
          this.cancel = false
          throw new Interrupt()
        }
      }.bind(this)
      this.$request.reservations
        .csvOperationData(params, progressFn)
        .then(items => {
          const tmp = this.reservationCsv(items)
          var m = moment()
          var output = m.format('YYYYMMDDHHmm')
          const fName = 'history_' + output + '.csv'
          downloadCsv(fName, tmp.header, tmp.data)
        })
        .catch(err => {
          if (err.status) {
            this.$notify({
              title: 'API Error',
              message: 'APIサーバでエラーが発生しました',
              type: 'error',
              duration: 10,
            })
          } else {
            this.$notify({
              message: '処理を中止しました',
            })
          }
          console.log(err)
        })
        .finally(() => {
          this.isDownloading = false
        })
    },
    fetchShopData () {
      this.isLoading = true
      this.$request.shops
        .list()
        .then(res => {
          this.shops = res.body.results.filter(x => x.shopType === ShopType.SHOP)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    reservationCsv (items) {
      // this.allFields
      // fields
      let fields = this.fields
      let tmp = this.allFields
      let header = []
      fields.forEach(function (value) {
        header.push(tmp[value])
      })
      let data = []
      items.forEach(function (item) {
        var tmp = []
        fields.forEach(function (field) {
          if (field === 'authenticationCode') {
            tmp.push(item[field] === '')
          } else if (field === 'fullName') {
            tmp.push(item['familyName'] + item['firstName'])
          } else if (field === 'fullnameKana') {
            tmp.push(item['familyNameKana'] + item['firstNameKana'])
          } else {
            tmp.push(item[field])
          }
        })
        data.push(tmp)
      })
      return { header, data }
    },
  },
}
</script>

<style>
.csv-shop-select .el-transfer-panel {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/Csv/Index.vue